import { Accordion, Box, IconChevronRight16, Link, Stack, Text } from '@stitch-fix/mode-react';
import { isNonEmptyString } from '../../utils/helpers';
type FAQLink = {
  href?: string;
  text?: string;
};
interface FAQItem {
  answer: string;
  link?: FAQLink;
  question: string;
}
export interface FAQsProps {
  items: FAQItem[];
  title?: string;
}
const shouldRenderLink = (link?: FAQLink) => isNonEmptyString(link?.href) && isNonEmptyString(link?.text);
export const FAQ = ({
  answer,
  link,
  question
}: FAQItem) => {
  return <Box m="0 auto" maxWidth="510px" py="12px">
      <Accordion expandIconAlignment="fixed-end" heading={question} headingLevel="none" headingSize="title-xsmall">
        <Stack spacing={0.5}>
          <Text setting="body-medium-fixed">{answer}</Text>
          {shouldRenderLink(link) && <Link endIcon={<IconChevronRight16 title="Go to link" />} href={link?.href} size="tertiary">
              {link?.text}
            </Link>}
        </Stack>
      </Accordion>
    </Box>;
};
export const FAQs = ({
  items,
  title
}: FAQsProps) => {
  return <Stack spacing={1}>
      <Text align="center" setting="title-medium">
        {title ?? 'FAQs'}
      </Text>
      <>
        {items.map(item => {
        return <div key={item.question}>
              <FAQ answer={item.answer} link={item.link} question={item.question} />
            </div>;
      })}
      </>
    </Stack>;
};